import { DatePicker, Input } from 'antd'
import { faBadge, faBarcode, faCalendar, faGraduationCap } from '@fortawesome/pro-solid-svg-icons'

import FormItem from '../../../Components/shared/Forms/FormItem'
import { Properties } from '../../../utils/entities/badge'
import AutoStudentsSelector from '../../../Components/shared/Selectors/Student/AutoStudentsSelector'
import { EUROPEAN_DATE } from '../../../utils/momentjs'
import { isMoment } from 'moment'

const FIELD_STYLE = { width: '100%' }

const { BADGE_NUMBER, RFID_NUMBER, START_DATE, END_DATE, STUDENT_ID } = Properties

const BadgeAssignationForm = ({ errorFields = [], data, onChange }) => {
  const className = field => errorFields.includes(field) ? 'error-ant-border' : ''

  return (
    <>
      <FormItem icon={faBadge} label='form.label.badge_number' required>
        <Input
          className={className(BADGE_NUMBER)}
          style={FIELD_STYLE}
          value={data[BADGE_NUMBER]}
          onChange={e => onChange(BADGE_NUMBER, e.target.value)}
        />
      </FormItem>
      <FormItem icon={faBarcode} label='form.label.rfid_number'>
        <Input
          style={FIELD_STYLE}
          value={data[RFID_NUMBER]}
          onChange={e => onChange(RFID_NUMBER, e.target.value)}
        />
      </FormItem>
      <FormItem icon={faCalendar} label='form.label.start_date' required>
        <DatePicker
          className={className(START_DATE)}
          style={FIELD_STYLE}
          value={data[START_DATE]}
          format={EUROPEAN_DATE}
          onChange={date => onChange(START_DATE, date)}
        />
      </FormItem>
      <FormItem icon={faCalendar} label='form.label.end_date'>
        <DatePicker
          style={FIELD_STYLE}
          value={isMoment(data[END_DATE]) ? data[END_DATE] : undefined}
          format={EUROPEAN_DATE}
          onChange={date => onChange(END_DATE, date)}
        />
      </FormItem>
      <FormItem className={className(STUDENT_ID)} icon={faGraduationCap} label='form.label.student' required>
        <AutoStudentsSelector
          style={FIELD_STYLE}
          values={data[STUDENT_ID]}
          onChange={studentId => onChange(STUDENT_ID, studentId)}
        />
      </FormItem>
    </>
  )
}

export default BadgeAssignationForm
